<template>
    <div class="tempControlInstallation" :class="getClass()">
        <i class="tempControlInstallation__button" @click.stop="buttonControl">{{ buttonText }}</i>
        <div class="tempControlInstallation__control">
            <i class="tempControlInstallation__order">{{ order }}º</i>
            <i class="tempControlInstallation__minus" @click.stop="minus"></i>
            <i class="tempControlInstallation__plus" @click.stop="plus"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ui-TempControlInstallation',
        props: {
            min: Number,
            max: Number,
            order: Number,
            active: {
                type: Boolean,
                default: false,
            },
            buttonText: String,
        },
        data: function() {
            return {
                step: 0.5,
                defaultTemperature: 22,
            };
        },
        methods: {
            getClass: function() {
                var classStyles = '';

                if (this.active) classStyles = 'tempControlInstallation--active';

                return classStyles;
            },
            buttonControl() {
                this.$emit('update:active', !this.active);
                this.$emit('update:order', this.defaultTemperature);
            },
            plus() {
                if (this.order < this.max) this.$emit('update:order', this.order + this.step);
            },
            minus() {
                if (this.order > this.min) this.$emit('update:order', this.order - this.step);
            },
        },
    };
</script>
